import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getColorFromString } from '../../utils/colorGenerator';
import { InsertSet } from 'shared/models';
import './InsertSetCard.css';

/**
 * A reusable card component for displaying insert set information
 */
const InsertSetCard = ({ insertSet, index = 0, linkUrl }) => {
  const backgroundColor = insertSet.imageUrl ? 'transparent' : getColorFromString(insertSet.id);

  return (
    <Link 
      to={linkUrl}
      className="insert-set-card"
      style={{ animationDelay: `${index * 0.05}s` }}
      title={insertSet.name}
    >
      <div 
        className="insert-set-card__image" 
        style={{
          backgroundColor: backgroundColor,
          backgroundImage: insertSet.imageUrl ? `url(${insertSet.imageUrl})` : 'none'
        }}
      >
        {!insertSet.imageUrl && insertSet.name.charAt(0)}
        {insertSet.totalCards > 0 && (
          <div className="insert-set-card__tag-area">
            <span className="insert-set-card__tag">{insertSet.totalCards} card{insertSet.totalCards != 1 && (<>s</>)}</span>
          </div>
        )}
      </div>
      <div className="insert-set-card__content">
        <div className="insert-set-card__text-area">
          <h3 className="insert-set-card__title">{insertSet.name}</h3>
        </div>
      </div>
    </Link>
  );
};

InsertSetCard.propTypes = {
  insertSet: PropTypes.instanceOf(InsertSet).isRequired,
  index: PropTypes.number,
  linkUrl: PropTypes.string.isRequired
};

export default InsertSetCard;